/**
 * http 请求拦截器
 * - 为所有请求加上共用的参数
 *
 * @since 1.0.0
 * @version 1.0.0
 */

import tokenReqInterceptor from './req-interceptor-token'
import APIUrlReqInterceptor from './req-interceptor-api-url'
import bodyReqInterceptor from './req-interceptor-body'
// import paramsReqInterceptor from './req-interceptor-params'

/**
 * 请求拦截器
 *
 * @param {object} config - http 配置参数
 * @returns {object} - 新的 http 请求参数
 */
export default function requestInterceptor(config) {
  config = tokenReqInterceptor(config)

  // 对请求地址url进行处理
  config = APIUrlReqInterceptor(config)

  // 对post请求头为application/x-www-form-urlencoded类型的数据做序列化处理
  config = bodyReqInterceptor(config)

  // 对请求参数附加默认的参数处理
  // config = paramsReqInterceptor(config)

  return config
}
